import { render } from "./OrderShipDetail.vue?vue&type=template&id=2ed56ef1&scoped=true"
import script from "./OrderShipDetail.vue?vue&type=script&lang=js"
export * from "./OrderShipDetail.vue?vue&type=script&lang=js"

import "./OrderShipDetail.vue?vue&type=style&index=0&id=2ed56ef1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed56ef1"]])

export default __exports__